import React, { FC } from 'react';
import { Button, HStack } from '@chakra-ui/react';

interface Props {
  view: string;
  onChangeView: (val: string) => void;
  views: {
    label: string;
    value: string;
  }[];
}

const Toggle: FC<Props> = ({ view, onChangeView, views }) => {
  return (
    <HStack
      w={['100%', 'fit-content']}
      alignItems="flex-start"
      gap="3px"
      px="4px"
      py="4px"
      sx={{
        background: 'neutral.1000',
        border: '1px solid',
        borderColor: 'neutral.700',
        borderRadius: '6px'
      }}
    >
      {views.map(item => {
        return (
          <Button
            key={item.value}
            variant="tertiary"
            onClick={() => {
              onChangeView(item.value);
            }}
            sx={{
              padding: '4px 24px',
              color: view === item.value ? 'orange' : 'gray.4',
              bg: view === item.value ? 'gray.2' : 'transparent'
            }}
            size="md"
          >
            {item.label}
          </Button>
        );
      })}
    </HStack>
  );
};

export default Toggle;
